import React, { useContext } from "react";
import Grid from '@mui/material/Grid2';
import { CatalogContext } from "@common/components/CatalogProvider";
import TicketBadge from "@common/components/TicketBadge";
import { Avatar, AvatarProps, styled } from "@mui/material";
import { Device } from "@services/devices/types";
import { getModelLogo } from "@common/utils/devices/logo";
import IconCardButton from "@common/components/IconCardButton";
import { LocationCity, LaptopRounded } from "@mui/icons-material";
import { Room } from "@assets/icons";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";

const DeviceImage = styled(({ logo, ...other }: { logo: any } & AvatarProps) =>
  typeof logo === "string" ? (
    <Avatar {...other} src={logo} />
  ) : (
    <Avatar {...other}>{logo}</Avatar>
  )
)(({ theme }) => ({
  border: `2px solid ${theme.palette.common.white}`,
  borderRadius: theme.spacing(1.5),
  height: "60px",
  width: "60px",
}));

const DeviceHeader = ({
  device,
  fullWidth = false,
}: {
  device?: Device;
  fullWidth?: boolean;
}) => {
  const catalog = useContext(CatalogContext);
  const logo = getModelLogo(
    __symphony_env__.REACT_APP_SERVER_URL,
    device,
    catalog
  );
  const context = React.useContext(RoomsRealtimeContext);
  const meeting = context.detail?.meeting;

  return (
    <Grid
      container
      direction="row"
      wrap="nowrap"
      sx={(theme) => ({
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(1),
        width: "auto",
        maxWidth: "100%",
        justifyContent: "space-between",
        gap: 1
      })}
    >
      <Grid>
        <DeviceImage logo={logo} />
      </Grid>
      <Grid
        sx={{
          flex: 1
        }}>
        <Grid
          container
          sx={{
            display: "grid",
            gridTemplateColumns: fullWidth ? "100%" : "50% 50%",
            "& > *": { margin: 0.5 }
          }}>
          <IconCardButton
            label={device?.name ?? ""}
            icon={<LaptopRounded />}
            href={`/assets/devices/${device?.id}`}
            previous={`${meeting?.title}`}
            disabled={device?.id === undefined}
            tooltip
          />
          <IconCardButton
            label={device?.room?.name ?? ""}
            icon={<Room />}
            href={`/assets/rooms/${device?.room?.id}`}
            previous={`${meeting?.title}`}
            disabled={device?.room?.id === undefined}
            tooltip
          />
          <IconCardButton
            label={device?.room?.location?.name ?? ""}
            icon={<LocationCity />}
            href={`/assets/locations/${device?.room?.location?.id}`}
            previous={`${meeting?.title}`}
            disabled
            tooltip
          />
        </Grid>
      </Grid>
      <Grid
        sx={{
          visibility: (device?.numOpenTickets ?? 0) > 0 ? "visible" : "hidden",
        }}>
        <TicketBadge
          notificationsNumber={device?.numOpenTickets}
          deviceId={device?.id ?? ""}
          previousPage={meeting?.title}
        />
      </Grid>
    </Grid>
  );
};

export default DeviceHeader;
